module.exports = __webpack_public_path__ + "images/tabs/reports-off.png";